import React from 'react';
import { Box, Button, Flex, Text } from 'pounceV2';
import { useTheme } from '@mui/material';
import ConversationInputV3 from 'Components/AI/Conversations/ConversationInputV3';
import type { Attachment } from 'Components/AIExplainLogEvents/hooks/useAIAttachments';
import { AISummarizeKind, OutputLength } from 'Generated/schema';

interface AlertTriageEmptyStateV3Props {
  kind: AISummarizeKind;
  onStartTriage: () => void;
  onSubmit: (message: string, outputLength: OutputLength) => void;
  cancelPrompt: () => void;
  onAttachFile?: (file: File) => void;
  isAttachDisabled?: boolean;
  isUploading?: boolean;
  attachments?: Attachment[];
  onRemoveAttachment?: (id: string) => void;
}

const AlertTriageEmptyStateV3: React.FC<AlertTriageEmptyStateV3Props> = ({
  kind,
  onStartTriage,
  onSubmit,
  cancelPrompt,
  onAttachFile,
  isAttachDisabled,
  isUploading,
  attachments,
  onRemoveAttachment,
}) => {
  const {
    palette: { tokens },
  } = useTheme();

  return (
    <Box display="flex" flexDirection="column" flex={1} minHeight={0}>
      <Flex direction="column" align="center" justify="center" flex={1} gap={3} px={6}>
        <Text color={tokens.content.text.neutral[3]} textAlign="center">
          Start a new AI-powered triage for{' '}
          {kind === AISummarizeKind.AlertList ? 'these alerts' : 'this alert'},{'\n'}or ask your own
          question below.
        </Text>
        <Button variant="primary" onClick={onStartTriage}>
          Start AI Triage
        </Button>
      </Flex>
      <Box pl={6} pr={20} pt={2} pb={4}>
        <ConversationInputV3
          kind={kind}
          onSubmit={onSubmit}
          isLoading={false}
          disabled={false}
          cancelPrompt={cancelPrompt}
          placeholder="Or ask your own question..."
          onAttachFile={onAttachFile}
          isAttachDisabled={isAttachDisabled}
          isUploading={isUploading}
          attachments={attachments}
          onRemoveAttachment={onRemoveAttachment}
        />
      </Box>
    </Box>
  );
};

export default AlertTriageEmptyStateV3;
